import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoCSSBuyRoupas() {
  return (
    <ArtigoPlaceholder
      title="Guia de Roupas por Atacado: Como Comprar da China com CSSBuy Spreadsheet"
      desc="Descubra como encontrar roupas de alta qualidade a preços de atacado usando as planilhas CSSBuy. Dicas de tamanhos, tecidos e fornecedores confiáveis para maximizar sua economia."
      icon="ri-t-shirt-line"
      slug="artigo-cssbuy-roupas"
    />
  );
}